import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import ActiveBanner from '../components/session/ActiveBanner.svelte';
import Card from '../components/shared/Card.svelte';
import Button from '../components/shared/Button.svelte';
import { navigate } from '../lib/router.svelte.ts';
import { getLastSession, getSessionsByDay } from '../lib/services/session';
import { formatRelativeTime } from '../lib/utils/time';
import { getSettings } from '../lib/stores/settings.svelte.ts';
import { getActiveChild } from '../lib/stores/children.svelte.ts';
import { formatVolume } from '../lib/utils/units.ts';

var root_2 = $.from_html(`<div class="last-feed svelte-1rx58b779oxt6"><span class="last-feed-label svelte-1rx58b779oxt6">Last feed</span> <span class="last-feed-time svelte-1rx58b779oxt6"> </span> <span class="last-feed-type svelte-1rx58b779oxt6"> <!><!></span></div>`);
var root_6 = $.from_html(`<div class="last-feed svelte-1rx58b779oxt6"><span class="last-feed-label svelte-1rx58b779oxt6">Welcome to mamaobaby</span> <span class="last-feed-type svelte-1rx58b779oxt6">Tap below to log your first feed</span></div>`);
var root_8 = $.from_html(`<div class="summary-item svelte-1rx58b779oxt6"><span class="summary-value svelte-1rx58b779oxt6"> </span> <span class="summary-label svelte-1rx58b779oxt6">nursing</span></div>`);
var root_9 = $.from_html(`<div class="summary-item svelte-1rx58b779oxt6"><span class="summary-value svelte-1rx58b779oxt6"> </span> <span class="summary-label svelte-1rx58b779oxt6">pumped</span></div>`);
var root_10 = $.from_html(`<div class="summary-item svelte-1rx58b779oxt6"><span class="summary-value svelte-1rx58b779oxt6"> </span> <span class="summary-label svelte-1rx58b779oxt6">bottle</span></div>`);
var root_7 = $.from_html(`<div class="today-summary svelte-1rx58b779oxt6"><h3 class="svelte-1rx58b779oxt6">Today</h3> <div class="summary-row svelte-1rx58b779oxt6"><!> <!> <!></div></div>`);
var root = $.from_html(`<!> <!> <div class="home-page svelte-1rx58b779oxt6"><!> <div class="quick-actions svelte-1rx58b779oxt6"><button class="quick-btn svelte-1rx58b779oxt6"><span class="quick-icon svelte-1rx58b779oxt6">🤱</span> <span class="quick-label svelte-1rx58b779oxt6">Nurse</span></button> <button class="quick-btn svelte-1rx58b779oxt6"><span class="quick-icon svelte-1rx58b779oxt6">🍼</span> <span class="quick-label svelte-1rx58b779oxt6">Pump</span></button> <button class="quick-btn svelte-1rx58b779oxt6"><span class="quick-icon svelte-1rx58b779oxt6">🧴</span> <span class="quick-label svelte-1rx58b779oxt6">Bottle</span></button></div> <!> <div class="history-link svelte-1rx58b779oxt6"><!></div></div>`, 1);

function Home($$anchor, $$props) {
	$.push($$props, true);

	const activeChild = $.derived(getActiveChild);
	let lastSession = $.state(void 0);
	let todaySessions = $.state($.proxy([]));

	$.user_effect(() => {
		if (!$.get(activeChild)) return;

		const id = $.get(activeChild).id;

		Promise.all([getLastSession(id), getSessionsByDay(id, Date.now())]).then(([ls, today]) => {
			$.set(lastSession, ls, true);
			$.set(todaySessions, today, true);
		});
	});

	const settings = $.derived(getSettings);
	const isImperial = $.derived(() => $.get(settings).units === 'imperial');
	const todayNursing = $.derived(() => $.get(todaySessions).filter((s) => s.type === 'nursing').length);
	const todayPumped = $.derived(() => $.get(todaySessions).filter((s) => s.type === 'pumping').reduce((sum, s) => sum + (s.volumeMl || 0), 0));
	const todayBottle = $.derived(() => $.get(todaySessions).filter((s) => s.type === 'bottle').reduce((sum, s) => sum + (s.volumeMl || 0), 0));
	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, { title: 'mamaobaby' });

	var node_1 = $.sibling(node, 2);

	ActiveBanner(node_1, {});

	var div = $.sibling(node_1, 2);
	var node_2 = $.child(div);

	{
		var consequent_2 = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_3 = $.first_child(fragment_1);

			Card(node_3, {
				padding: 'md',
				children: ($$anchor, $$slotProps) => {
					var div_1 = root_2();
					var span = $.sibling($.child(div_1), 2);
					var text = $.child(span, true);

					$.reset(span);

					var span_1 = $.sibling(span, 2);
					var text_1 = $.child(span_1, true);
					var node_4 = $.sibling(text_1);

					{
						var consequent = ($$anchor) => {
							var text_2 = $.text();

							$.template_effect(() => $.set_text(text_2, `· ${$.get(lastSession).side ?? ''}`));
							$.append($$anchor, text_2);
						};

						$.if(node_4, ($$render) => {
							if ($.get(lastSession).side) $$render(consequent);
						});
					}

					var node_5 = $.sibling(node_4);

					{
						var consequent_1 = ($$anchor) => {
							var text_3 = $.text();

							$.template_effect(($0) => $.set_text(text_3, `· ${$0 ?? ''}`), [
								() => formatVolume($.get(lastSession).volumeMl, $.get(isImperial))
							]);

							$.append($$anchor, text_3);
						};

						$.if(node_5, ($$render) => {
							if ($.get(lastSession).volumeMl) $$render(consequent_1);
						});
					}

					$.reset(span_1);
					$.reset(div_1);

					$.template_effect(
						($0) => {
							$.set_text(text, $0);
							$.set_text(text_1, $.get(lastSession).type);
						},
						[
							() => formatRelativeTime($.get(lastSession).endTime || $.get(lastSession).startTime)
						]
					);

					$.append($$anchor, div_1);
				},
				$$slots: { default: true }
			});

			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			var fragment_4 = $.comment();
			var node_6 = $.first_child(fragment_4);

			Card(node_6, {
				padding: 'md',
				children: ($$anchor, $$slotProps) => {
					var div_2 = root_6();

					$.append($$anchor, div_2);
				},
				$$slots: { default: true }
			});

			$.append($$anchor, fragment_4);
		};

		$.if(node_2, ($$render) => {
			if ($.get(lastSession)) $$render(consequent_2); else $$render(alternate, -1);
		});
	}

	var div_3 = $.sibling(node_2, 2);
	var button = $.child(div_3);
	var button_1 = $.sibling(button, 2);
	var button_2 = $.sibling(button_1, 2);

	$.reset(div_3);

	var node_7 = $.sibling(div_3, 2);

	{
		var consequent_6 = ($$anchor) => {
			var div_4 = root_7();
			var div_5 = $.sibling($.child(div_4), 2);
			var node_8 = $.child(div_5);

			{
				var consequent_3 = ($$anchor) => {
					var div_6 = root_8();
					var span_2 = $.child(div_6);
					var text_4 = $.child(span_2, true);

					$.reset(span_2);
					$.next(2);
					$.reset(div_6);
					$.template_effect(() => $.set_text(text_4, $.get(todayNursing)));
					$.append($$anchor, div_6);
				};

				$.if(node_8, ($$render) => {
					if ($.get(todayNursing) > 0) $$render(consequent_3);
				});
			}

			var node_9 = $.sibling(node_8, 2);

			{
				var consequent_4 = ($$anchor) => {
					var div_7 = root_9();
					var span_3 = $.child(div_7);
					var text_5 = $.child(span_3, true);

					$.reset(span_3);
					$.next(2);
					$.reset(div_7);
					$.template_effect(($0) => $.set_text(text_5, $0), [() => formatVolume($.get(todayPumped), $.get(isImperial))]);
					$.append($$anchor, div_7);
				};

				$.if(node_9, ($$render) => {
					if ($.get(todayPumped) > 0) $$render(consequent_4);
				});
			}

			var node_10 = $.sibling(node_9, 2);

			{
				var consequent_5 = ($$anchor) => {
					var div_8 = root_10();
					var span_4 = $.child(div_8);
					var text_6 = $.child(span_4, true);

					$.reset(span_4);
					$.next(2);
					$.reset(div_8);
					$.template_effect(($0) => $.set_text(text_6, $0), [() => formatVolume($.get(todayBottle), $.get(isImperial))]);
					$.append($$anchor, div_8);
				};

				$.if(node_10, ($$render) => {
					if ($.get(todayBottle) > 0) $$render(consequent_5);
				});
			}

			$.reset(div_5);
			$.reset(div_4);
			$.append($$anchor, div_4);
		};

		$.if(node_7, ($$render) => {
			if ($.get(todaySessions).length > 0) $$render(consequent_6);
		});
	}

	var div_9 = $.sibling(node_7, 2);
	var node_11 = $.child(div_9);

	Button(node_11, {
		variant: 'ghost',
		onclick: () => navigate('/log'),
		children: ($$anchor, $$slotProps) => {
			$.next();

			var text_7 = $.text('View History');

			$.append($$anchor, text_7);
		},
		$$slots: { default: true }
	});

	$.reset(div_9);
	$.reset(div);
	$.delegated('click', button, () => navigate('/session/nursing'));
	$.delegated('click', button_1, () => navigate('/session/pumping'));
	$.delegated('click', button_2, () => navigate('/session/bottle'));
	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	Home = $.hmr(Home);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-1rx58b779oxt6');
		Home[$.HMR].update(module.default);
	});
}

export default Home;

$.delegate(['click']);
import "bun-svelte:Home.svelte-3rt7dy6c4nidg-style.css";